export const Accordion = new function () {
  let accordionItems = [];

  this.init = () => {
    accordionItems = document.querySelectorAll('.sn-accordion');

    accordionItems.forEach(item => {
      const button = item.querySelector('.sn-accordion__header');
      const contentBody = item.querySelector('.sn-accordion__body');
      const content = item.querySelector('.sn-accordion__cnt');

      let contentHeight = content.scrollHeight;
      let itemHeight = item.scrollHeight;
      contentBody.style.setProperty('--height', `${contentHeight}px`);
      item.style.setProperty('--height', `${itemHeight}px`);

      if (button) {
        button.addEventListener('click', () => this.toggle(item));
      }
    });
  };

  this.toggle = (clickedItem) => {
    const isActive = clickedItem.classList.contains('active');

    accordionItems.forEach(item => item.classList.remove('active'));

    if (!isActive) {
      clickedItem.classList.add('active');
    }
  };
};
